export type ComponentsFormTranslation = {
  select: {
    noOptionsMessage: string;
    selected: string;
  };
};

export const componentsFormTranslation: ComponentsFormTranslation = {
  select: {
    noOptionsMessage: 'No options available',
    selected: 'Selected: {{value}}',
  },
};
